import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { apiClient } from '@/api/client'

export function useRegenerateAISummary() {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (gameId: string) => {
      const token = await getAccessTokenSilently({
        authorizationParams: {
          scope: 'openid profile email',
        },
      })
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
      const response = await apiClient.post(`/ai/game-summary/${gameId}`)
      return response.data
    },
    onSuccess: () => {
      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['game'] })
      queryClient.invalidateQueries({ queryKey: ['games'] })
      queryClient.invalidateQueries({ queryKey: ['team-stats'] })
    },
  })
}

